module.exports = __webpack_public_path__ + "img/tarik_komisi.33efefee.png";